import { OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource, MatSort, Sort } from '@angular/material';
import { EsGivingsService } from 'src/app/restapi/be-esquery';
import { take, tap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { dateFormat, DEFAULT_FORMATS } from 'src/app/share/utils/common-utils';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
var moment = _moment;
var ɵ0 = DEFAULT_FORMATS;
var GivingsPlaceComponent = /** @class */ (function () {
    function GivingsPlaceComponent(router, fb, esGivingsService) {
        this.router = router;
        this.fb = fb;
        this.esGivingsService = esGivingsService;
        this.dataList = [];
        this.dataSource = new MatTableDataSource([]);
        this.displayedColumns = [];
        this.defaultDisplayedColumns = ['date', 'department_name', 'team_name', 'location_name', 'give_route', 'give_count', 'give_unit_count', '의류', '잡화', '도서음반', '가전'];
        this.anonymousDisplayedColumns = ['date', 'department_name', 'team_name', 'location_name', 'give_count', 'give_unit_count', '의류', '잡화', '도서음반', '가전'];
        this.minDate = moment().add(-3, 'month');
        this.maxDate = moment();
    }
    GivingsPlaceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkPage();
        this.initForm();
        this.sort.sortChange.pipe(tap(function (sort) {
            _this.initPage(sort);
        }), takeUntil(componentDestroyed(this))).subscribe();
    };
    GivingsPlaceComponent.prototype.ngOnDestroy = function () { };
    // 기증처별통계, 기증처별 익명기증통계 구분
    // 화면이 동일함.
    GivingsPlaceComponent.prototype.checkPage = function () {
        if (this.router.url.includes('anonymous')) {
            this.isAnonymous = true;
            this.displayedColumns = this.anonymousDisplayedColumns;
        }
        else {
            this.isAnonymous = false;
            this.displayedColumns = this.defaultDisplayedColumns;
        }
    };
    GivingsPlaceComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            gte_date: this.minDate,
            lte_date: this.maxDate,
            dept_info: null,
            give_route: '' // 기증처별통계에서만 사용
        });
    };
    Object.defineProperty(GivingsPlaceComponent.prototype, "fc_gteDate", {
        get: function () { return this.form.get('gte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GivingsPlaceComponent.prototype, "fc_lteDate", {
        get: function () { return this.form.get('lte_date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GivingsPlaceComponent.prototype, "fc_deptInfo", {
        get: function () { return this.form.get('dept_info'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GivingsPlaceComponent.prototype, "fc_giveRoute", {
        get: function () { return this.form.get('give_route'); },
        enumerable: true,
        configurable: true
    });
    GivingsPlaceComponent.prototype.rangeComplete = function (event) {
        this.form.patchValue({
            gte_date: event.startDate,
            lte_date: event.endDate
        });
        //this.onClickSearch();
    };
    /*   onChangeStartDate() {
        const limitDate = moment(this.fc_gteDate.value).add(3, 'month');
        this.minDate = this.fc_gteDate.value;
    
        if (this.fc_gteDate.value > this.fc_lteDate.value) {
          this.fc_lteDate.setValue(this.fc_gteDate.value);
        }
    
        if (limitDate < this.fc_lteDate.value) {
          this.fc_lteDate.setValue(limitDate);
        }
      }
    
      onChangeEndDate() {
        const limitDate = moment(this.fc_lteDate.value).add(-3, 'month');
    
        if (limitDate > this.fc_gteDate.value) {
          this.fc_gteDate.setValue(limitDate);
          this.minDate = limitDate;
        }
      } */
    GivingsPlaceComponent.prototype.selectDept = function (value) {
        if (!value || value == null) {
            this.fc_deptInfo.setValue(null);
            return;
        }
        this.fc_deptInfo.setValue(value);
        this.search();
    };
    GivingsPlaceComponent.prototype.convertCategories = function (category, categories) {
        if (categories.find(function (x) { return x.category == category; })) {
            return categories.find(function (x) { return x.category == category; }).sum;
        }
        return "";
    };
    GivingsPlaceComponent.prototype.search = function () {
        this.givingsPlaceGet();
    };
    GivingsPlaceComponent.prototype.initPage = function (sort) {
        var _this = this;
        if (!this.dataList)
            this.dataList = [];
        var sorted = this.dataList;
        if (sort) {
            if (sort.active == '의류' || sort.active == '잡화' || sort.active == '도서음반' || sort.active == '가전') {
                sorted = this.dataList.sort(function (a, b) {
                    var result = 0;
                    var a_cate_sum = Number(_this.convertCategories(sort.active, a.categories));
                    var b_cate_sum = Number(_this.convertCategories(sort.active, b.categories));
                    if (a_cate_sum < b_cate_sum)
                        result = -1;
                    else if (a_cate_sum > b_cate_sum)
                        result = 1;
                    return result * (sort.direction === 'asc' ? 1 : -1);
                });
            }
            else {
                sorted = this.dataList.sort(function (a, b) {
                    var result = 0;
                    if (a[sort.active] == undefined)
                        a[sort.active] = "";
                    if (b[sort.active] == undefined)
                        b[sort.active] = "";
                    if (a[sort.active] < b[sort.active])
                        result = -1;
                    else if (a[sort.active] > b[sort.active])
                        result = 1;
                    return result * (sort.direction === 'asc' ? 1 : -1);
                });
            }
        }
        this.dataList = sorted;
        this.dataSource = new MatTableDataSource(this.dataList);
    };
    GivingsPlaceComponent.prototype.exportTOExcel = function () {
        var ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        var wb = XLSX.utils.book_new();
        if (this.isAnonymous) {
            XLSX.utils.book_append_sheet(wb, ws, '기증처별 익명기증 통계');
            XLSX.writeFile(wb, '기증처별 익명기증 통계.xlsx');
        }
        else {
            XLSX.utils.book_append_sheet(wb, ws, '기증처별 통계');
            XLSX.writeFile(wb, '기증처별 통계.xlsx');
        }
    };
    GivingsPlaceComponent.prototype.givingsPlaceGet = function () {
        var _this = this;
        this.dataList = [];
        this.esGivingsService.givingsPlaceGet(dateFormat(this.fc_gteDate.value), dateFormat(this.fc_lteDate.value), this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null, this.isAnonymous ? null : this.fc_giveRoute.value, this.isAnonymous ? 'Y' : null).pipe(take(1)).subscribe(function (res) {
            _this.dataList = res;
            _this.initPage(_this.sort);
        }, function (err) {
            console.error(err);
            _this.initPage(_this.sort);
        });
    };
    return GivingsPlaceComponent;
}());
export { GivingsPlaceComponent };
export { ɵ0 };
